import React from 'react';
import { inject, observer } from 'mobx-react';
import { useTranslation } from 'react-i18next';
import { Dialog, DialogContent, DialogActions, Button, Typography } from '@material-ui/core';
import createStyles from '@material-ui/core/styles/createStyles';
import makeStyles from '@material-ui/core/styles/makeStyles';
import { Theme } from '@material-ui/core/styles/createTheme';
import compose from 'helpers/compose';
import { UserStoreKC, ViewKeys, maxLoginLengthKey } from 'stores/userStoreKC';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    content: {
      padding: theme.spacing(3),
      textAlign: 'center',
    },
  }),
);

interface Props {
  userStore?: UserStoreKC;
}

const SessionExpiringDialog: React.FC<Props> = ({ userStore }) => {
  const classes = useStyles();
  const { t } = useTranslation();
  const { loginExpiring, setViewSetting, view } = userStore!;
  const time = new Date(Number(localStorage.getItem(maxLoginLengthKey) || 0) * 1000).toLocaleTimeString('cs', {
    hour: '2-digit',
    minute: '2-digit',
  });

  return (
    <Dialog open={loginExpiring && !view[ViewKeys.HIDE_LOGIN_EXPIRING]} maxWidth="xs" fullWidth>
      <DialogContent className={classes.content}>
        <Typography variant="h3">{t('general_user_loginExpiring',{time})}</Typography>
      </DialogContent>
      <DialogActions>
        <Button variant="contained" color="primary" onClick={() => setViewSetting(ViewKeys.HIDE_LOGIN_EXPIRING, true)}>
          {t('general_ok')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default compose(inject('userStore'), observer)(SessionExpiringDialog);
